import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

AOS.init({
  once: true,        // animasi cuma sekali
  duration: 800,     // smooth
  easing: 'ease-out-cubic',
  offset: 80,
});

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const featuredMotors = [
  {
    id: 1,
    name: "Honda Stylo 160",
    tagline: "Elegan & Modern untuk Tampil Beda",
    description:
      "Skuter matic bergaya retro modern dengan performa bertenaga dan fitur canggih untuk menunjang mobilitas harian",
    image:
      "/assets/motor/StyloHome.jpg",
    imageAlt:
      "Honda Stylo 160 stylish retro modern scooter parked on city street",
    price: "Rp 29.463.000",
    priceStart: "Mulai dari",
    badge: "New Model",
    badgeColor: "bg-success",
    features: ["eSP+", "CBS", "Smart Key"],
    specs: {
      engine: "156.9 cc (eSP+)",
      power: "15.8 PS",
      fuel: "±45 km/l"
    }
  }, 

  {
    id: 2,
    name: "Honda Vario 160",
    tagline: "Sporty & Stylish untuk Gaya Hidup Aktif",
    description:
      "Kombinasi sempurna antara performa sporty dan efisiensi bahan bakar untuk pengendara dinamis",
    image:
      "/assets/motor/VarioHome.jpg",
    imageAlt:
      "Honda Vario 160 red sporty scooter with aggressive styling and modern LED headlights in outdoor urban environment",
    price: "Rp 28.342.000",
    priceStart: "Mulai dari",
    badge: "Terlaris 2026",
    badgeColor: "bg-warning",
    features: ["eSP+", "CBS", "Smart Key"],
    specs: {
      engine: "156.9 cc (eSP+)",
      power: "15.4 PS",
      fuel: "±46 km/l"
    }
  },
    {
    id: 3,
    name: "Honda PCX 160",
    tagline: "Kenyamanan Premium untuk Perjalanan Anda",
    description:
      "Motor matic premium dengan teknologi terkini dan desain elegan yang sempurna untuk mobilitas urban modern",
    image:
      "/assets/motor/PcxHome.jpg",
    imageAlt:
      "Honda PCX 160 silver metallic scooter with sleek modern design parked in urban setting with glass building background",
    price: "Rp 34.592.000",
    priceStart: "Mulai dari",
    badge: "Best Seller",
    badgeColor: "bg-primary",
    features: ["CBS", "Smart Key", "HSTC"],
    specs: {
      engine: "156.9 cc (eSP+)",
      power: "15.8 PS",
      fuel: "±45 km/l"
    }
  }
];



  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredMotors?.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, featuredMotors?.length]);

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + featuredMotors?.length) % featuredMotors?.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % featuredMotors?.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const currentMotor = featuredMotors?.[currentSlide];

  return (
    <section className="relative bg-gradient-to-br from-background via-muted to-background overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5" />
      <div className="container mx-auto px-4 pt-6 md:pt-8 lg:pt-10 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div className="space-y-6 md:space-y-8 relative z-10" data-aos="fade-right">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full">
              <Icon name="Award" size={18} color="var(--color-primary)" />
              <span className="text-sm font-heading font-semibold text-primary">
                Dealer & Ahass Resmi Honda Terpercaya
              </span>
            </div>

            <div className="space-y-4">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground leading-tight">
                Wujudkan Impian Berkendara Anda Bersama{' '}
                <span className="text-primary">Honda <br /> Berdikari Pamulang</span>
              </h1>
              <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
                Dealer & Ahass Resmi Honda dengan layanan terbaik, kredit mudah, dan purna jual terpercaya di Tangerang Selatan
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="Search"
                iconPosition="left"
                onClick={() => window.location.href = '/produk/motor'}
                className="shadow-honda-subtle">

                Lihat Semua Motor
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Calculator"
                iconPosition="left"
                onClick={() => window.location.href = '/credit-simulation'}>

                Simulasi Kredit
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-4 pt-4" data-aos="fade-up"data-aos-delay="200">
              <div className="text-center p-4 bg-card rounded-lg">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary">15+</div>
                <div className="text-xs md:text-sm text-muted-foreground mt-1">Tahun Pengalaman</div>
              </div>
              <div className="text-center p-4 bg-card rounded-lg">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary">50K+</div>
                <div className="text-xs md:text-sm text-muted-foreground mt-1">Pelanggan Puas</div>
              </div>
              <div className="text-center p-4 bg-card rounded-lg">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary">4.9</div>
                <div className="text-xs md:text-sm text-muted-foreground mt-1">Rating Google</div>
              </div>
            </div>
          </div>

          <div className="relative" data-aos="fade-left">
            <div className="relative bg-card rounded-2xl shadow-card-hover overflow-hidden">
              <div className="absolute top-4 left-4 z-20">
                <span className={`${currentMotor?.badgeColor} text-white px-4 py-2 rounded-full text-sm font-heading font-semibold shadow-lg`}>
                  {currentMotor?.badge}
                </span>
              </div>

              <div className="aspect-[4/3] relative overflow-hidden">
                <Image
                  src={currentMotor?.image}
                  alt={currentMotor?.imageAlt}
                  className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              </div>

              <div className="p-6 md:p-8 space-y-4">
                <div>
                  <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-2">
                    {currentMotor?.name}
                  </h3>
                  <p className="text-sm md:text-base text-primary font-heading font-semibold mb-3">
                    {currentMotor?.tagline}
                  </p>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {currentMotor?.description}
                  </p>
                </div>

                <div className="flex flex-wrap gap-2">
                  {currentMotor?.features?.map((feature, index) =>
                  <span
                    key={index}
                    className="px-3 py-1 bg-muted rounded-full text-xs font-medium text-foreground">

                      {feature}
                    </span>
                  )}
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-border">
                  <div>
                    <p className="text-xs text-muted-foreground">{currentMotor?.priceStart}</p>
                    <p className="text-xl md:text-2xl font-heading font-bold text-primary">
                      {currentMotor?.price}
                    </p>
                  </div>
                  <Button
                    variant="default"
                    size="default"
                    iconName="MessageCircle"
                    iconPosition="right"
                    onClick={() => window.open('https://wa.me/6288293642972?text=Halo, saya tertarik dengan ' + currentMotor?.name, '_blank')}>

                    Konsultasi
                  </Button>
                </div>
              </div>
            </div>

            <button
              onClick={handlePrevSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-card hover:bg-primary rounded-full flex items-center justify-center shadow-lg transition-all duration-300 group z-20"
              aria-label="Previous slide">

              <Icon name="ChevronLeft" size={24} className="text-foreground group-hover:text-primary-foreground transition-colors" />
            </button>

            <button
              onClick={handleNextSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-card hover:bg-primary rounded-full flex items-center justify-center shadow-lg transition-all duration-300 group z-20"
              aria-label="Next slide">

              <Icon name="ChevronRight" size={24} className="text-foreground group-hover:text-primary-foreground transition-colors" />
            </button>

            <div className="flex justify-center space-x-2 mt-6">
              {featuredMotors?.map((_, index) =>
              <button
                key={index}
                onClick={() => handleSlideChange(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                index === currentSlide ? 'w-8 bg-primary' : 'w-2 bg-muted hover:bg-primary/50'}`
                }
                aria-label={`Go to slide ${index + 1}`} />

              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;